import ResultItem from './ResultItem';
import type { RelatedApprovalItem } from './types';

type ResultListProps = {
  items: RelatedApprovalItem[];
  onSelect: (item: RelatedApprovalItem) => void;
  onOpenInNewWindow: (docId: string) => void;
  onItemKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
};

// 외부 박스는 ResultLayer(ResultListBox) 소유 — 여기는 row 평면 매핑만
const ResultList = ({
  items,
  onSelect,
  onOpenInNewWindow,
  onItemKeyDown,
}: ResultListProps) => (
  <>
    {items.map((item) => (
      <ResultItem
        key={item.docId}
        item={item}
        onSelect={onSelect}
        onOpenInNewWindow={onOpenInNewWindow}
        onKeyDown={onItemKeyDown}
      />
    ))}
  </>
);

export default ResultList;
